module.exports = __webpack_public_path__ + "img/icon_item.9e072dec.png";